<script lang="ts">
  /**
   * Toast container component
   * Displays all active toasts in a fixed position
   * Add this once to App.svelte
   */

  import { toastStore } from '$lib/stores/toast';
  import Toast from './Toast.svelte';

  $: toasts = $toastStore.toasts;
</script>

<div class="toast-container" aria-live="polite" aria-atomic="true">
  {#each toasts as toast (toast.id)}
    <Toast
      id={toast.id}
      type={toast.type}
      message={toast.message}
      onDismiss={toastStore.dismiss}
    />
  {/each}
</div>

<style>
  .toast-container {
    position: fixed;
    top: 1rem;
    right: 1rem;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    pointer-events: none;
  }

  .toast-container :global(.toast) {
    pointer-events: auto;
  }

  @media (max-width: 640px) {
    .toast-container {
      left: 1rem;
      right: 1rem;
      align-items: stretch;
    }
  }
</style>
